import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H2 } from 'UIComponents/elements/headings';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { getProductNameTextFromApiName } from '../../common/adapters/getProductNameText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TallDialogBody = styled(UIDialogBody).withConfig({
  displayName: "Tx120SurveyLoadingModal__TallDialogBody",
  componentId: "sc-1epamtj-0"
})(["height:250px;"]);
const Tx120SurveyLoadingModal = ({
  onLoadingFinish,
  apiName
}) => {
  const isMounted = useRef(false);
  const productName = getProductNameTextFromApiName(apiName);
  useEffect(() => {
    if (!isMounted.current) {
      setTimeout(() => {
        onLoadingFinish();
        isMounted.current = true;
      }, 2500);
    }
  }, [onLoadingFinish]);
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "success",
    width: 600,
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        direction: "column",
        align: "center",
        justify: "center",
        className: "text-center",
        children: [/*#__PURE__*/_jsx(UIIllustration, {
          name: "successfully-submitted-question",
          width: "20%"
        }), /*#__PURE__*/_jsx(H2, {
          style: {
            fontWeight: 400,
            fontSize: '22px'
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.tx0120.common.trialTitle",
            options: {
              productName
            }
          })
        }), /*#__PURE__*/_jsx(H2, {
          style: {
            fontSize: '24px'
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.tx0120.common.modalTitle"
          })
        })]
      })
    }), /*#__PURE__*/_jsx(TallDialogBody, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        direction: "column",
        align: "center",
        justify: "between",
        className: "p-top-10",
        children: [/*#__PURE__*/_jsx(UILoadingSpinner, {
          size: "small"
        }), /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.tx0120.loadingModal.loadingSpinner.paragraph1"
          })
        }), /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.tx0120.loadingModal.loadingSpinner.paragraph2"
          })
        })]
      })
    })]
  });
};
export default Tx120SurveyLoadingModal;